import { useState, useEffect, useRef, useCallback } from "react";
import {
  HERO_VIDEOS,
  HERO_VIDEO_CROSSFADE_INTERVAL_MS,
  HERO_VIDEO_CROSSFADE_DURATION_MS,
} from "./constants";

const FADE_DURATION_MS = HERO_VIDEO_CROSSFADE_DURATION_MS / 2;

export function useHeroCrossfade() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const indexRef = useRef(0);
  const [fading, setFading] = useState(false);

  const swapSource = useCallback(() => {
    setFading(true);

    setTimeout(() => {
      indexRef.current = indexRef.current === 0 ? 1 : 0;
      const video = videoRef.current;
      if (video) {
        video.src = HERO_VIDEOS[indexRef.current];
        video.load();
        video.play().catch(() => {});
      }
      setFading(false);
    }, FADE_DURATION_MS);
  }, []);

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (prefersReducedMotion) return;

    const interval = setInterval(swapSource, HERO_VIDEO_CROSSFADE_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [swapSource]);

  return { videoRef, fading, initialSrc: HERO_VIDEOS[0] };
}
